import { SessionContext } from '@/providers/SessionProvider';
import moment from 'moment';
import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { confirm } from '@/lib/confirm';
import toast from 'react-hot-toast';
import { FiSend, FiTrash2 } from 'react-icons/fi';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { AvatarWrapper } from '@/components/ui/avatar';
import { PostActionsButton, PostActionsItem, PostActionsWrapper, PostComment, PostCommentBody, PostCommentContent, PostCommentHeader, PostCommentName, PostCommentText, PostCommentTime } from '@/components/custom/post';

export function FeedCommentAnswers({ onSubmit, answers, isOpenAnswer, onDelete = () => null }) {
  const state = useContext(SessionContext);
  const [answerValue, setAnswerValue] = useState('');
  const [showLess, setShowLess] = useState(true);

  const handleSubmit = () => {
    onSubmit(answerValue);
    setAnswerValue('');
  };

  const handleDeleteAnswer = async answerId => {
    const confirmed = await confirm({
      title: 'Deseja mesmo excluir este comentário?',
      description: 'Esta ação não poderá ser desfeita',
      confirmText: 'Sim',
      cancelText: 'Não'
    });
    if (confirmed) {
      await onDelete(answerId);
      toast.success('Comentário excluído com sucesso');
    }
  };

  return (
    <div>
      {isOpenAnswer && (
        <div className="mt-3 flex gap-2">
          <Input
            aria-label="Respondendo"
            placeholder="Respondendo"
            value={answerValue}
            onChange={e => setAnswerValue(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                handleSubmit();
              }
            }}
          />
          <Button
            size="icon"
            type="submit"
            className="shrink-0"
            onClick={handleSubmit}
          >
            <FiSend />
          </Button>
        </div>
      )}

      {answers.length > 0 && (
        <>
          {answers.map((item, index) => (
            <PostComment
              key={item.id}
              style={{ display: (showLess && index === 0) || (showLess && index === 1) ? 'grid' : (index !== 0 && showLess) || (index !== 1 && showLess) ? 'none' : 'grid', gridTemplateColumns: '30px 1fr 16px' }}
            >
              <Link to={`/usuario/metricas/${item.user.id}`}>
                <AvatarWrapper
                  size="sm"
                  src={item?.user?.image?.url}
                  text={item?.user?.name}
                />
              </Link>

              <PostCommentContent className="w-full">
                <PostCommentHeader>
                  <PostCommentName>
                    <Link to={`/usuario/metricas/${item.user.id}`}>{item?.user?.name}</Link>
                  </PostCommentName>
                  <PostCommentTime>{moment(item['created_at'] || item['created-at']).fromNow()}</PostCommentTime>
                </PostCommentHeader>

                <PostCommentBody>
                  <PostCommentText className="m-0 break-words">{item.body}</PostCommentText>
                </PostCommentBody>
              </PostCommentContent>

              {state.session && state.session.user.id === item?.user?.id && (
                <PostActionsWrapper className="w-full self-start">
                  <PostActionsItem className="flex-row justify-end">
                    <PostActionsButton
                      isDanger
                      className="mr-0"
                      onClick={() => handleDeleteAnswer(item.id)}
                    >
                      <FiTrash2 size={16} />
                    </PostActionsButton>
                  </PostActionsItem>
                </PostActionsWrapper>
              )}
            </PostComment>
          ))}

          {answers.length > 2 && (
            <Button
              variant="link"
              size="xs"
              onClick={() => setShowLess(prev => !prev)}
            >
              {showLess ? 'mostrar mais' : 'mostrar menos'}
            </Button>
          )}
        </>
      )}
    </div>
  );
}
